import axios, { encodeData } from "../utils/axios";

export const fetchApplicationDocuments = async (id) => {
  const res = await axios
    .get("/applicationDocuments/application/", { params: { id: id } })
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });

  return res.data;
};

export const fetchApplicationDocumentsExternalUser = async (id) => {
  // console.log("fetchApplicationDocumentsExternalUser " + id)
  const res = await axios
    .get("/applicationDocuments/application/external-user", {
      params: { id: id },
    })
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });
  // console.log('fetchApplicationDocumentsExternalUser return');
  // console.log(res?.data);
  return res?.data;
};

export const updateApplicationDocument = async (updatedApplicationDocument) => {
  await axios.put(
    "/applicationDocuments/updateStatus",
    encodeData(updatedApplicationDocument)
  );
};
